<template>
  <div>
    <!-- 列表 -->
    <!-- 1保修信息 2投诉建议 3违章举报 4水质检测报告 5水表检测报告 -->
    <div class="topic-List" v-show="type === 1">
      <div class="topic-tit">
        <h2>{{obj.ftypename}}</h2>
        <p>{{obj.fbilldate}}</p>
      </div>
      <div class="topic-con">
        <p><span>单据号：</span>{{obj.fbillno}}</p>
        <p><span>所属区域：</span>{{obj.fareaname1}}/{{obj.fareaname2}}</p>
        <p><span>联系电话：</span>{{obj.fopermobile}}</p>
      </div>
      <div class="topic-rig">
        <p style="margin-top:60%;">{{obj.fapplyname}}</p>
        <van-button class="comm-small-btn" native-type="button" color="#6096F8" @click="info" style="height:20px;">
          查看
        </van-button>
      </div>
    </div>
    <div class="topic-List" v-show="type === 2" @click="info">
      <div class="topic-con">
        <p><span>单据号：</span>{{obj.fbillno}}</p>
        <p><span>联系人：</span>{{obj.foper}}</p>
        <p><span>详细描述：</span>{{obj.fnetmark}}</p>
        <p><span>申请时间：</span>{{obj.fbilldate}}</p>
      </div>
      <div class="topic-rig">
        <p style="margin-top: 10%;">{{obj.fapplyname}}</p>
        <van-button class="comm-small-btn" native-type="button" color="#6096F8" @click="info" style="height:20px;">
          查看
        </van-button>
      </div>
    </div>
    <div class="topic-List" v-show="type === 3" @click="info">
      <div class="topic-con">
        <p><span>单据号：</span>{{obj.fbillno}}</p>
        <p><span>联系人：</span>{{obj.foper}}</p>
        <p><span>违章地址：</span>{{obj.fviolationaddr}}</p>
        <p><span>申请时间：</span>{{obj.fbilldate}}</p>
      </div>
      <div class="topic-rig">
        <p style="margin-top: 10%;">{{obj.fapplyname}}</p>
        <van-button class="comm-small-btn" native-type="button" color="#6096F8" @click="info" style="height:20px;">
          查看
        </van-button>
      </div>
    </div>
    <div class="topic-List" v-show="type === 4">
      <!-- <div class="topic-tit">
          <h2>{{obj.ftrantypename}}</h2>
          <p>{{obj.fbilldate}}</p>
        </div> -->
      <div class="topic-con">
        <p><span>联系人：</span>{{obj.foper}}</p>
        <p><span>单据号：</span>{{obj.fbillno}}</p>
        <p><span>地址：</span>{{obj.faddr}}</p>
        <p><span>说明：</span>{{obj.fnetcontent}}</p>
        <p><span>检测说明：</span>{{obj.fnetsummary}}</p>
      </div>
      <div class="topic-rig">
        <van-button class="comm-small-btn" native-type="button" color="#6096F8" @click="report('水质检测报告')" style="height:20px;">
          查看
        </van-button>
      </div>
    </div>
    <div class="topic-List" v-show="type === 5">
      <div class="topic-tit">
        <h2>{{obj.ftrantypename}}</h2>
        <p>{{obj.fbilldate}}</p>
      </div>
      <div class="topic-con">
        <p><span>联系人：</span>{{obj.foper}}</p>
        <p><span>用水地址：</span>{{obj.ffixaddr}}</p>
        <p><span>缴费号：</span>{{obj.fuserno}}</p>
        <p><span>单据号：</span>{{obj.fbillno}}</p>
      </div>
      <div class="topic-rig">
        <van-button class="comm-small-btn" native-type="button" color="#6096F8" @click="report('水表检测报告')" style="height:20px;">
          查看
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: Number,
    obj: Object
  },
  data() {
    return {
    }
  },
  mounted() {
    // if (this.$route.query.active) {
    //   this.active = Number(this.$route.query.active)
    // }
  },

  methods: {
    info() {
      this.$comm.mineinfo(this.obj)
    },
    report(title) {
      this.$comm.reportinfo(this.obj, title)
    }
  },
}
</script>

<style lang="less" scoped>
.topic-List {
  background: #fff;
  border-radius: 5px;
  padding: 6px;
  position: relative;
  .topic-tit {
    display: flex;
    align-items: center;
    padding: 8px;
    border-bottom: 1px solid #eeeeee;
    h2 {
      color: #333;
      font-size: 15px;
      margin: 0;
      width: 50%;
    }
    p {
      color: #a1a1a1;
      font-size: 13px;
      margin: 0;
    }
  }
  .topic-con {
    padding: 8px;
    p {
      color: #333;
      font-size: 14px;
      margin: 0;
      line-height: 1.8em;
      span {
        font-weight: bold;
      }
    }
  }
  .topic-rig {
    position: absolute;
    right: 5%;
    top: 50%;
    transform: translateY(-50%);
    color: #6096f8;
    font-size: 16px;
    font-weight: bold;
    p {
      text-align: center;
    }
  }
}
</style>